import { Component } from '@angular/core';

@Component({
    selector: 'view-child-course-history',
    templateUrl: './view-child-course-history.component.html',
    styleUrl: './view-child-course-history.component.scss'
})
export class ViewChildCourseHistoryComponent {}
